type TFormatPhoneNumberOptions = {
  fallback?: string;
};

const DEFAULT_PHONE_FALLBACK = "-";

const toDigits = (value: string): string => value.replace(/\D/g, "");

const formatUsLocalNumber = (digits: string): string => {
  if (digits.length !== 10) {
    return digits;
  }

  const areaCode = digits.slice(0, 3);
  const prefix = digits.slice(3, 6);
  const lineNumber = digits.slice(6);
  return `(${areaCode}) ${prefix}-${lineNumber}`;
};

export const formatPhoneNumberDisplay = (
  value: string | null | undefined,
  options: TFormatPhoneNumberOptions = {},
): string => {
  const fallback = options.fallback || DEFAULT_PHONE_FALLBACK;
  const normalizedValue = (value || "").trim();
  if (!normalizedValue) {
    return fallback;
  }

  const hasPlusPrefix = normalizedValue.startsWith("+");
  const digits = toDigits(normalizedValue);
  if (!digits) {
    return fallback;
  }

  // US E.164: +1XXXXXXXXXX
  if (hasPlusPrefix && digits.length === 11 && digits.startsWith("1")) {
    return `+1 ${formatUsLocalNumber(digits.slice(1))}`;
  }

  // US domestic number
  if (!hasPlusPrefix && digits.length === 10) {
    return formatUsLocalNumber(digits);
  }

  // US with leading 1
  if (!hasPlusPrefix && digits.length === 11 && digits.startsWith("1")) {
    return `+1 ${formatUsLocalNumber(digits.slice(1))}`;
  }

  // Generic international fallback with minimal grouping
  if (hasPlusPrefix && digits.length > 1) {
    const countryCodeLength = Math.min(3, Math.max(1, digits.length - 10));
    const countryCode = digits.slice(0, countryCodeLength);
    const localDigits = digits.slice(countryCodeLength);

    if (localDigits.length === 10) {
      return `+${countryCode} ${formatUsLocalNumber(localDigits)}`;
    }

    return `+${countryCode} ${localDigits}`;
  }

  return normalizedValue;
};
